/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React from 'react';

interface Props {
    height?: string | number;
    width?: string | number;
    className?: string;
}

export default function Ideal(props: Props) {
    const width = props.width ?? '32', height = props.height ?? '32', {className} = props;
    return (
        <svg className={className} height={height} width={width} viewBox="0 0 463 400" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="nonzero">

                <path d="M0 0h463v400H0z" fill="#fff" />
                <g transform="scale(20.3) translate(-1.58 -1.58)">
                    <path
                        d="M13.321 21.296H3.206A1.628 1.628 0 0 1 1.58 19.67V3.182c.001-.898.729-1.625 1.626-1.626h10.115c9.593 0 11.026 6.17 11.026 9.848 0 6.381-3.916 9.892-11.026 9.892zM3.206 2.098c-.598 0-1.084.485-1.085 1.084V19.67c.001.599.487 1.084 1.085 1.084h10.115c6.76 0 10.484-3.32 10.484-9.35 0-8.097-6.569-9.306-10.484-9.306H3.206z"
                        fill="#000" />
                    <path
                        d="M7.781 4.78v14.377h6.259c5.686 0 8.151-3.213 8.151-7.746 0-4.342-2.465-7.716-8.151-7.716H8.865c-.598 0-1.084.485-1.084 1.084z"
                        fill="#C06" />
                    <path fill="#FFF"
                        d="M19.713 9.47v2.8h1.674v.635h-2.429V9.47zM17.199 9.47l1.285 3.435H17.7l-.26-.762h-1.285l-.27.762h-.762l1.3-3.435h.776zm.043 2.107l-.433-1.26H16.8l-.447 1.26h.89zM14.612 9.47v.635h-1.814v.736h1.665v.587h-1.665v.842h1.853v.635h-2.607V9.47zM9.985 9.47c.21-.002.42.034.617.106.187.068.356.176.496.318.146.15.257.331.328.529.082.24.122.492.117.746.002.234-.03.467-.096.692-.059.2-.157.387-.29.549-.133.156-.3.28-.487.363-.216.093-.45.138-.685.132H8.503V9.47h1.482zm-.053 2.8a.983.983 0 0 0 .317-.053.703.703 0 0 0 .275-.176.888.888 0 0 0 .192-.319c.052-.155.076-.318.072-.481a2.04 2.04 0 0 0-.05-.47.932.932 0 0 0-.17-.357.74.74 0 0 0-.305-.23 1.212 1.212 0 0 0-.47-.079h-.538v2.165h.677z" />
                    <path
                        d="M4.953 13.683a1.2 1.2 0 0 1 1.2 1.2v4.274a2.401 2.401 0 0 1-2.401-2.401v-1.872a1.2 1.2 0 0 1 1.2-1.2z"
                        fill="#000" />
                    <circle fill="#000" cx="4.953" cy="11.188" r="1.585" />
                </g>
            </g>
        </svg>
    )
}